import { useDeviceClass } from '../../../shared/hooks/useDeviceClass';
import { WorkflowDesktopView } from '../views/WorkflowDesktopView';
import { WorkflowMobileView } from '../views/WorkflowMobileView';
import { WorkflowTabletView } from '../views/WorkflowTabletView';

export function WorkflowPage() {
  const device = useDeviceClass();
  if (device === 'mobile') return <WorkflowMobileView />;
  if (device === 'tablet') return <WorkflowTabletView />;
  return <WorkflowDesktopView />;
}
